import React, {useState, useEffect, useRef} from 'react';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function TeamOutsideInvitationsListItem({outside_invitation, ndx}) 
{
    const { app_user, team, team_member_role, setTeamDisplayRefresh } = useCTAL();

    const [error, setError] = useState();
        
    const tooltipRef_resend = useRef(null);
    const tooltipRef_cancel = useRef(null);

    useEffect(() => {
        const tooltip_resend = new window.bootstrap.Tooltip(tooltipRef_resend.current, { container: 'body', trigger: 'hover' });
        const tooltip_cancel = new window.bootstrap.Tooltip(tooltipRef_cancel.current, { container: 'body', trigger: 'hover' });
        return () => { tooltip_resend.dispose(); tooltip_cancel.dispose(); };
    }, []);

    useEffect(() =>
    {
        var is_disabled = true;
        if (team_member_role == "Admin") is_disabled = false;
        
        if (DEBUG) console.log(`TeamOutsideInvitationsListItem - team_member_role: ${team_member_role}`);

        document.getElementById(outside_invitation.OutsideInvitationID+"-resend-btn").disabled = is_disabled;
        document.getElementById(outside_invitation.OutsideInvitationID+"-cancel-btn").disabled = is_disabled;
    }, [team]);

    const handle_response = (res) => { 
        if (DEBUG) console.log(`TeamOutsideInvitationsListItem - res.message: ${res.message}`);
    }

    const send_request = (body) => { 
        console.log(`TeamOutsideInvitationsListItem - Send Request body: ${body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-upd`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
            .then(response => response.json())
            .then(handle_response)
            .then(() => setTeamDisplayRefresh(true))
            .catch(setError);
    }

    const cancel_team_outside_invitation = () => { 
        if (!outside_invitation) return;
        if (team_member_role != "Admin") return; //Icon button should be Disabled, but let's be carefull

        var type = "cancel_team_outside_invitation";

        var team_id           = team.TeamID;
        var outside_invite_id = outside_invitation.OutsideInvitationID;
        var invitee_full_name = outside_invitation.InvitedUserFullName;
        var user_full_name    = app_user.UserFullName;

        var body = JSON.stringify({type, team_id, outside_invite_id, invitee_full_name, user_full_name});

        send_request(body);
    }

    const resend_team_outside_invitation = () => { 
        if (!outside_invitation) return;
        if (team_member_role != "Admin") return; //Icon button should be Disabled, but let's be carefull

        var type = "resend_team_outside_invitation";

        var team_id           = team.TeamID;
        var outside_invite_id = outside_invitation.OutsideInvitationID;
        var invitee_full_name = outside_invitation.InvitedUserFullName;
        var user_full_name    = app_user.UserFullName;

        var body = JSON.stringify({type, team_id, outside_invite_id, invitee_full_name, user_full_name});

        send_request(body);
    }

    var CreatedDT = new Date(outside_invitation.CreatedAt);
    const formattedDate = CreatedDT.toLocaleString("en-US", {
        day: "numeric",
        month: "short",
        //year: "numeric",
      });


    var invite_destination;
    if (outside_invitation.invitedUserContactPref == "SMS")
        invite_destination = outside_invitation.InvitedUserPhoneNumber;
    else
        invite_destination = outside_invitation.InvitedUserEmail;

    return (
        <>
            <li class="list-group-item list-group-item-action">
                
                <div class="row">
                    <div class="col-9 text-start">
                        <b>{outside_invitation.InvitedUserFullName}</b> <small>({outside_invitation.InvitationStatus})</small>
                    </div>
                    <div class="col-3 text-end" >
                        <a href="#" id={outside_invitation.OutsideInvitationID+"-resend-btn"} ref={tooltipRef_resend} data-bs-toggle="tooltip" data-bs-title="Resend Invitation" data-bs-delay="750"><img class="list_item_icon"     src="./images/resend.svg" alt="accept" border="0" onClick={ () => resend_team_outside_invitation() }/></a>                                
                        <a href="#" id={outside_invitation.OutsideInvitationID+"-cancel-btn"} ref={tooltipRef_cancel} data-bs-toggle="tooltip" data-bs-title="Cancel Invitation" data-bs-delay="750"><img class="list_item_icon-end" src="./images/trash.svg"  alt="ignore" border="0" onClick={ () => cancel_team_outside_invitation() }/></a>                                
                    </div>  
                </div>

                <div class="row">
                    <div class="col-12">
                        <div><small><i>invited on {formattedDate} by {outside_invitation.CreatedBy} </i></small></div>
                        <small>sent via {outside_invitation.invitedUserContactPref} to {invite_destination}</small>
                    </div>
                </div>

            </li>
        </>
    );
}